import Box from '@/buyers/components/Box'
import { Link, useLocation } from 'react-router-dom'
import { activateUrlWithReturnPath } from '../modules/ReturnPath'

/**
 * The limited router's fallthrough — everything an unclaimed, invited user can't be
 * served yet. It used to render Not Found, which was both untrue (the page usually
 * exists; they just can't reach it unclaimed) and a dead end: the destination they
 * were sent went with it. Now it names the destination and carries it through the
 * claim step as a `return_path` (GEA-7070).
 *
 * `/` reaches this page too — it is where a plain login lands
 * (`GfProxy.Auth.parse_redirect/1`) and the limited router has no route for it — so
 * that case gets the same offer without pretending a bare `/` is a destination
 * anyone was "sent to".
 */
const LimitedClaimRequired = () => {
  const { pathname, search, hash } = useLocation()
  const destination = `${pathname}${search}${hash}`
  const wasSentSomewhere = pathname !== '/'

  return (
    <div className="py-8">
      <Box className="text-base space-y-3">
        <div className="text-lg">Claim your account to continue.</div>

        <p>
          {wasSentSomewhere ? (
            <>
              You were sent to <span className="font-medium break-all">{destination}</span>.
              Claiming your free Gearflow account takes a minute, and we&apos;ll bring you straight
              there.
            </>
          ) : (
            <>
              Claiming your free Gearflow account takes a minute, and it opens up the rest of Parts
              Hub — requests, orders, your team.
            </>
          )}
        </p>

        <p>
          <Link
            to={wasSentSomewhere ? activateUrlWithReturnPath(destination) : '/activate'}
            className="text-blue-500 underline underline-offset-2"
          >
            Claim your account
          </Link>
        </p>

        <div className="text-sm text-gray-500">For help, contact support@gearflow.com</div>
      </Box>
    </div>
  )
}

export default LimitedClaimRequired
